import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import s from "./Game.module.scss";

import EventPubSub from "scripts/util/EventPubSub";
// import Config from 'scripts/util/Config'
import MainExperience from "scripts/3d/experience/Main";

import Hammer from "react-hammerjs";
import GameUI from "components/GameUi3D";

import AudioManager from "scripts/util/AudioManager";
import { useCallback } from "react";
import store from "store";
import { setState } from "store/game";
import useQuery from "hooks/useQuery";

Game.defaultProps = {};

const translate = {
  loading: {
    en: "Loading...",
    es: "Cargando...",
  }
}

export default function Game({ onComplete }) {
  const [loaded, setLoaded] = useState(false);
  const [enableGameDuration, setEnableGameDuration] = useState(false);
  const { character, gameDuration } = useSelector((state) => state.game);
  const lang = useQuery().get("lang") || "en";

  const gameover = useCallback((msg) => {
    if (msg === "gameDestroy") {
      setEnableGameDuration(false);
      onComplete();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!MainExperience.running) {
      MainExperience.init(document.getElementById("canvas"));
      MainExperience.loadClones().then(() => {
        MainExperience.load(character).then(() => {
          MainExperience.initExperience();
          setLoaded(true);
          setEnableGameDuration(true);
        });
      });
      AudioManager.playTrack("gameMusic");
    }

    document.addEventListener("keyup", keyboardHandler, false);
    document.addEventListener("keydown", keyboardPress, false);
    EventPubSub.subscribe("game", gameover);

    return () => {
      document.removeEventListener("keyup", keyboardHandler);
      document.removeEventListener("keydown", keyboardPress, false);
      EventPubSub.unsubscribe("game", gameover);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (enableGameDuration) {
      setTimeout(() => {
        store.dispatch(setState({ gameDuration: gameDuration + 1 }));
      }, 1000);
    }
  }, [gameDuration, enableGameDuration]);

  const keyboardHandler = (event) => {
    if (window.parent) {
      window.parent.postMessage("iframe action", "*");
    }
    if (event.code === "ArrowUp") {
      EventPubSub.emit("remote", "up");
    }
    if (event.code === "ArrowLeft") {
      EventPubSub.emit("remote", "left");
    }
    if (event.code === "ArrowRight") {
      EventPubSub.emit("remote", "right");
    }
    if (event.code === "ArrowDown") {
      EventPubSub.emit("remote", "down");
    }
    if (event.code === "Space") {
      EventPubSub.emit("remote", "pressUp");
    }
    if (event.code === "Enter") {
      EventPubSub.emit("remote", "action");
    }
  };

  const keyboardPress = (event) => {
    if (event.code === "Space") {
      EventPubSub.emit("remote", "press");
    }
  };

  const onSwipe = ({ direction }) => {
    switch (direction) {
      case 2: //left
        EventPubSub.emit("remote", "left");
        break;
      case 8: //up
        EventPubSub.emit("remote", "up");
        break;
      case 4: //right
        EventPubSub.emit("remote", "right");
        break;
      case 16: //down
        // EventPubSub.emit("remote", "down")
        break;
      default:
      // do nothing
    }
  };
  const onPress = (event) => {
    EventPubSub.emit("remote", "press");
  };
  const onPressUp = (event) => {
    EventPubSub.emit("remote", "pressUp");
  };

  // const gameover = () => {
  //   onComplete()
  // }

  return (
    <div className={s.Game}>
      <Hammer
        onSwipe={onSwipe}
        onPress={onPress}
        onPressup={onPressUp}
        direction="DIRECTION_ALL"
      >
        <canvas className={s.Canvas} id="canvas" />
      </Hammer>
      <div className={s.FPS} id="fpsLabel"></div>
      {loaded && <GameUI />}

      {/* {Config.isDebug() && <button className='btn' style={{ position: 'fixed', top: '10vw', zIndex: '10000' }} onClick={ () => {
        MainExperience.pause()
        onComplete('winner')
      }}>Finish Game</button> } */}
      {!loaded && (
        <div className={s.Loading}>
          {/* <img className={s.snow} src={require('assets/images/new-ui/loading-background-nochar.jpg').default} alt=""/>
        <img className={s.character} src={require(`assets/images/character-${character}-happy.png`).default} alt=""/> */}
          <img
            className={s.snow}
            src={
              require("assets/images/2024-ui/loading.jpg")
                .default
            }
            alt=""
          />
          <h1>
            {translate.loading[lang]}
          </h1>
        </div>
      )}
    </div>
  );
}
